var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAddMarketHoliday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "32px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-826.000000, -882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(826.000000, 882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.741464,25 L24,18.2109581 L24,5 C24,4.44771525 23.5522847,4 23,4 L2,4 C1.44771525,4 1,4.44771525 1,5 L1,24 C1,24.5522847 1.44771525,25 2,25 L17.741464,25 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5,
    y: 0,
    width: 2,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 18,
    y: 0,
    width: 2,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 11.5,
    y: 0,
    width: 2,
    height: 7,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(17.000000, 18.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddMarketHoliday);
export default __webpack_public_path__ + "static/media/ico_add-market-holiday.5f6d0a6f5baea9d0c84818f9a6e4f8ff.svg";
export { ForwardRef as ReactComponent };